<script>
import Page from '../../../../resources/frontend/js/mixins/page.vue';

export default {
    mixins: [Page],

    data() {
        return {
            options: {
                'h1': 'header-1',
                'h2': 'header-2',
                'h3': 'header-3',
                'h4': 'header-4',
                'h5': 'header-5',
                'h6': 'header-6',
                'p': 'paragraph',
                'body': 'paragraph',
                'textarea': 'paragraph',
                ':where(p, b, i, s, u, span):has(.tiny-text), .tiny-text': 'tiny-text',
            },

            defaultFont: '',
            defaultColor: '#000000',
            settings: {},
        };
    },

    methods: {
        fillData() {
            const generalStyling = this.$store.state.styling.typography;
            const pageStyling = this.get('general.style.typography') ? 'general.style.typography' : 'general.typography';

            Object.keys(generalStyling).length !== 0 ? this.settings = generalStyling : this.settings = this.get(pageStyling);

            if (this.settings['default-font'] && this.getFontFamily(this.settings['default-font'].value)) {
                this.defaultFont = `"${this.getFontFamily(this.settings['default-font'].value)}", ${this.defaultFont}`;
            }

            this.convertValues(this.settings);
            this.addTypography(this.settings);
        },

        convertValues(settings) {
            for (const key of Object.keys(settings)) {
                if (key === '_info') continue;
                if (settings[key]['value']) continue;
                if (key.startsWith('default-')) continue;

                if (this.getFontFamily(settings[key].font.value)) {
                    settings[key].font.value = `"${this.getFontFamily(settings[key].font.value)}", ${this.defaultFont}`;
                } else {
                    settings[key].font.value = this.defaultFont;
                }

                settings[key]['font-size-mobile']['value'] = this.getMobileValue(settings[key]['font-size-mobile']['value']);
                settings[key]['line-height-mobile']['value'] = this.getMobileValue(settings[key]['line-height-mobile']['value']);

                settings[key]['font-size-desktop']['value'] = this.getDesktopValue(settings[key]['font-size-desktop']['value']);
                settings[key]['line-height-desktop']['value'] = this.getDesktopValue(settings[key]['line-height-desktop']['value']);
            }
        },

        getMobileValue(value) {
            return (value / 6.4) + 'vw';
        },

        getDesktopValue(value) {
            return value + 'px';
        },

        addTypography(settings) {
            document.documentElement.style.setProperty('--default-color', settings['default-color'].value);
            document.documentElement.style.setProperty('--default-font', this.defaultFont);

            for (const [key, value] of Object.entries(settings)) {
                if (typeof value !== 'object') continue;
                if (!value.font) continue;

                document.documentElement.style.setProperty(`--${key}-font`, value.font.value);
                document.documentElement.style.setProperty(`--${key}-font-size-mobile`, value['font-size-mobile'].value);
                document.documentElement.style.setProperty(`--${key}-line-height-mobile`, value['line-height-mobile'].value);
                document.documentElement.style.setProperty(`--${key}-font-size-desktop`, value['font-size-desktop'].value);
                document.documentElement.style.setProperty(`--${key}-line-height-desktop`, value['line-height-desktop'].value);
                document.documentElement.style.setProperty(`--${key}-font-weight-regular`, value['fontWeightRegular']?.value ?? '400');
                document.documentElement.style.setProperty(`--${key}-font-weight-bold`, value['fontWeightBold']?.value ?? '700');
                document.documentElement.style.setProperty(`--${key}-font-weight-light`, value['fontWeightLight']?.value ?? '300');
            }
        },
    },

    created() {
        this.defaultFont = getComputedStyle(document.querySelector('body')).fontFamily;
        if (this.defaultFont === 'Times' || this.defaultFont === '"Times New Roman"' || this.defaultFont === '-webkit-standard') this.defaultFont = '"Open Sans", sans-serif';
    },

    mounted() {
        this.fillData();
    },
};
</script>

<style lang="scss">
@use '../../scss/extends/responsive' as *;

$options: (
    'body': 'paragraph',
    'p': 'paragraph',
    ':where(p, b, i, s, u, span):has(.tiny-text), .tiny-text': 'tiny-text',
    'h1': 'header-1',
    'h2': 'header-2',
    'h3': 'header-3',
    'h4': 'header-4',
    'h5': 'header-5',
    'h6': 'header-6',
    'textarea': 'paragraph',
);

@layer reset {
    @each $selector, $type in $options {
        @if $selector != 'body' {
            #{$selector} {
                font-family: var(--#{$type}-font);
            }
        }

        #{$selector},
        #{$selector} * {
            font-size: var(--#{$type}-font-size-mobile);
            line-height: var(--#{$type}-line-height-mobile);
            font-weight: var(--#{$type}-font-weight-regular);

            @include desktop {
                font-size: var(--#{$type}-font-size-desktop);
                line-height: var(--#{$type}-line-height-desktop);
                font-weight: var(--#{$type}-font-weight-regular);
            }
        }

        #{$selector}:has(.light-weight) > * {
            font-weight: var(--#{$type}-font-weight-light) !important;
        }

        #{$selector} b,
        #{$selector} b * {
            font-weight: var(--#{$type}-font-weight-bold);
        }
    }

    b:has(.tiny-text) {
        .tiny-text {
            font-weight: var(--tiny-text-font-weight-bold) !important;
        }
    }

    h1, h2, h3, h4, h5, h6, p {
        &:has([style*="font-family"] .tiny-text) {
            .tiny-text {
                font-family: inherit;
            }
        }
    }

    body {
        font-family: var(--default-font);
        color: var(--default-color);
    }
}
</style>
